import { ref } from '@vue/composition-api';
import { IAdClient } from '@/bundles/Ad/interfaces';
import { adClientService } from '@/bundles/Ad/factory/adClientServiceFactory';
import AdClient from '@/bundles/Ad/models/AdClient';
import { ICreateAdClientDto, IUpdateAdClientDto } from '@/bundles/Ad/dto';

export function useAdClient () {
  const defaultAdClientData: IAdClient = {
    id: 0,
    created: new Date(),
    updated: new Date(),
    name: '',
    active: true,
  };
  const adClientItems = ref<IAdClient[]>([]);
  const listLoading = ref(false);
  const total = ref(0);

  async function fetch () {
    listLoading.value = true;
    const response = await adClientService.getList();
    adClientItems.value = response.data;
    total.value = response.total
    listLoading.value = false;
  }

  const createLoading = ref(false);
  const editLoading = ref(false);
  const adClient = ref(new AdClient(defaultAdClientData));
  async function createClient (payload: ICreateAdClientDto) {
    createLoading.value = true;
    await adClientService.create(payload)
      .finally(() => createLoading.value = false);
  }
  async function editClient (id: number, payload: IUpdateAdClientDto) {
    editLoading.value = true;
    await adClientService.update(id, payload)
      .finally(() => editLoading.value = false);
  }

  return {
    adClientItems,
    listLoading,
    total,
    defaultAdClientData,
    editLoading,
    createLoading,
    createClient,
    adClient,
    editClient,
    fetch,
  };
}
